// small pure helpers shared by the support ticket pages

// the Assigned pick: Unassigned, the Initek staff roster, then every user on
// the selected account (a customer-admin can own a ticket too -- Ben,
// 2026-09-24). account users already on the staff list are not repeated.
export function assigneeChoices(staffOptions, accountUsers) {
  const seen = new Set((staffOptions || []).map(o => o.value))
  const extra = (accountUsers || []).filter(o => o && o.value && !seen.has(o.value))
  if (!extra.length)
    return staffOptions || []
  return [...(staffOptions || []), { value: '__account_users__', text: '\u2014 Account users \u2014', disabled: true }, ...extra]
}

// the Created By pick: the Initek staff first (a staff member opening a
// ticket as themselves), then the account's users under a header (Ben,
// 2026-09-24: dev team first in both picks). "Unassigned" is an assignee
// notion and is dropped; account users already on the staff list are not
// repeated.
export function requesterChoices(accountUsers, staffOptions) {
  const staff = (staffOptions || []).filter(o => o && o.value)
  const seen = new Set(staff.map(o => o.value))
  const users = (accountUsers || []).filter(o => o && o.value && !seen.has(o.value))
  if (!users.length)
    return staff
  if (!staff.length)
    return users
  return [...staff, { value: '__account_users__', text: '\u2014 Account users \u2014', disabled: true }, ...users]
}

// the people a ticket belongs to, for the Mine chip and the team photo chips:
// the assignee and the requester (Created By). created_by (whoever physically
// opened the ticket) is deliberately excluded — a staff-written ticket set up
// for a customer should not land in the staffer's Mine lane just because they
// clicked create, since that value is invisible in the UI (Ben, 2026-09-25).
export function ticketPeople(ticket) {
  const people = []
  ;[ticket && ticket.assigned_to, ticket && ticket.username].forEach(p => {
    if (p && !people.includes(p)) people.push(p)
  })
  return people
}

export function ticketInvolves(ticket, username) {
  return !!username && ticketPeople(ticket).includes(username)
}
